import { FC } from 'react';
import ProtectWithLogin from '../../ProtectWithLogin/ProtectWithLogin';
import ReplyIcon from '../Icons/ReplyIcon';

type TCommentReplyButtonProps = {
  onClick: () => void;
};

const CommentReplyButton: FC<TCommentReplyButtonProps> = ({ onClick }) => (
  <div className="relative flex items-center gap-x-3">
    <ProtectWithLogin>
      <button
        onClick={onClick}
        className="relative flex h-8 items-center active:-ml-[6px] active:justify-center fill-gray-600 active:bg-red-100 active:w-8 active:h-8 active:rounded-full hover:!fill-orange-500 peer after:absolute after:left-8 after:top-1 after:content-['Reply'] after:text-gray-600 after:text-base after:active:ml-[6px] after:hover:text-orange-500"
      >
        <ReplyIcon />
      </button>
    </ProtectWithLogin>
  </div>
);

export default CommentReplyButton;
